/** cSpell:ignore Popconfirm */
import React from 'react';
import { Popconfirm } from 'antd';

import './index.less';

export default ({ placement = 'top', icon = null, children, overlayClassName, ...rest }) => (
  <Popconfirm
    overlayClassName={`${overlayClassName || ''} ${!!icon ? '' : 'popUp-noPadding'}`}
    placement={placement}
    icon={icon}
    okType="btn-info"
    {...rest}
  >
    {children}
  </Popconfirm>
);
